const { debounce } = window.BAO.Utils

class GiftBox extends window.BAO.CustomElement() {
  constructor () {
    super()

    this._loading = false
    this.sections = this.inPushCart
      ? window.BAO.sectionRenderer.pushCartSections
      : this.onCartPage
        ? window.BAO.sectionRenderer.cartSections
        : []

    const cartState = this.cartState

    cartState.items.forEach(item => {
      if (
        item.id === parseInt(this.dataset.variantId) &&
        cartState.items.length === 1
      ) {
        this.removeGiftItem()
      }
    })
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.onCheckboxStateChange = this.onCheckboxStateChange.bind(this)
    this.removeGiftItem = this.removeGiftItem.bind(this)
    this.addGiftItem = this.addGiftItem.bind(this)

    this.onQuantityChange = this.onQuantityChange.bind(this)
    this.debouncedOnQuantityChange = debounce(event => {
      this.onQuantityChange(event)
    }, 500)

    this.listeners.add(
      this.els.checkbox.element,
      'change',
      this.onCheckboxStateChange,
    )
    this.listeners.add(
      this,
      window.BAO.EVENTS.QUANTITY_ADJUSTER.CHANGE,
      this.debouncedOnQuantityChange,
    )
  }

  async onQuantityChange (e) {
    // - Change the quantity of the gift line item, if it exists
    // - Reference the line item id as defined on the form
    if (!this.dataset.key) return

    this.loading = true

    const state = await window.BAO.Cart.updateQuantity(
      this.dataset.key,
      e.detail.value,
      { sections: this.mappedSections },
    )

    this.loading = false

    if ('sections' in state) this.renderSections(state.sections)
  }

  onCheckboxStateChange (e) {
    // Add or remove the gift item to the cart
    // Calls removeGiftItem or addGiftItem
    if (this.els.checkbox.element.checked) {
      this.addGiftItem(e)
    } else {
      this.removeGiftItem(e)
    }
  }

  async removeGiftItem (e) {
    // - Remove the gift item from the cart, referencing the line item id defined on the form element
    // - Remove the line item id from the form element
    this.loading = true

    const state = await window.BAO.Cart.removeItem(this.dataset.key, {
      sections: this.mappedSections,
    })

    this.loading = false

    if ('sections' in state) this.renderSections(state.sections)
  }

  async addGiftItem () {
    // - Add the gift item to the cart
    // - Add the line item id to the gift form element

    this.loading = true

    const productData = {
      products: [
        {
          id: parseInt(this.dataset.variantId),
          quantity: parseInt(
            this.els.quantity.element.querySelector('#Quantity').value,
          ),
        },
      ],
    }

    const state = await window.BAO.Cart.addItem(productData.products)

    this.dataset.key = state.items[0]?.id

    this.loading = false
  }

  get mappedSections () {
    return this.sections.map(s => s.section)
  }

  get loading () {
    return this._loading
  }

  set loading (val) {
    this._loading = val

    if (this.inPushCart) {
      this.pushCart.loading = val
    }

    this.setAttribute('aria-busy', val.toString())
  }

  get pushCart () {
    return this.closest('push-cart')
  }

  get inPushCart () {
    return this.pushCart != null
  }

  get cart () {
    return this.closest('.crt-GiftBox')
  }

  get cartState () {
    return JSON.parse(this.externalEls['cart-state'].element.textContent)
  }

  get onCartPage () {
    return this.cart != null
  }
}

if (!customElements.get('gift-box')) {
  customElements.define('gift-box', GiftBox)
}
